import React, { useState, useEffect } from 'react';
import GeoGebraMySolAnimation from '../components/GeoGebraMySolAnimation';
import { useParams, useLocation, useNavigate } from 'react-router-dom';
// import '../App.css';

const DoorProblemMySolAnimation = ()=> {
    const {doorProIDMy}=useParams();
    const navigateto = useNavigate();
    const {problemURL, problemInfo, myAnswerList, myConstructionStep, myAnswerRaw, myPointConstruction, doorProbIDMy} = useLocation().state;
    // const [randomString1, setRandomString1] = useState();
    // const [randomString2, setRandomString2] = useState();
    // const [randomString3, setRandomString3] = useState();
    // const [randomString4, setRandomString4] = useState();
    // const [randomString5, setRandomString5] = useState();

    // useEffect(() => {
    //     const revivalData = () => {
    //         const letters = '1234567890';
    //         let randomString1l = '';
    //         let randomString2l = '';
    //         let randomString3l = '';
    //         let randomString4l = '';
    //         let randomString5l = '';
    //         for (let i = 0; i < 3; i++) {
    //             randomString1l += letters[Math.floor(Math.random() * letters.length)];
    //         }
    //         setRandomString1(randomString1l); 
    //         for (let i = 0; i < 8; i++) {
    //             randomString2l += letters[Math.floor(Math.random() * letters.length)];
    //         }
    //         setRandomString2(randomString2l);
    //         for (let i = 0; i < 5; i++) {
    //             randomString3l += letters[Math.floor(Math.random() * letters.length)];
    //         }
    //         setRandomString3(randomString3l);
    //         for (let i = 0; i < 7; i++) {
    //             randomString4l += letters[Math.floor(Math.random() * letters.length)];
    //         }
    //         setRandomString4(randomString4l);
    //         for (let i = 0; i < 6; i++) {
    //             randomString5l += letters[Math.floor(Math.random() * letters.length)];
    //         }
    //         setRandomString5(randomString5l);
    //     };
    //     revivalData();
    // },[doorProIDMy])

    return(
        <div className="problem" key={myAnswerRaw.answerMark}>
            <div className="content-fit">
                <h4>{myAnswerRaw.solvingTime.substring(6,10)}년 {myAnswerRaw.solvingTime.substring(3,5)}월 {myAnswerRaw.solvingTime.substring(0,2)}일 {myAnswerRaw.solvingTime.substring(12,17)}의 풀이</h4>
                <GeoGebraMySolAnimation
                    idIn={problemInfo.problemCode}
                    customToolBarIn={problemInfo.customToolBar}
                    allowStyleBarIn={problemInfo.allowStyleBar}
                    ggbBase64In={problemInfo.problemContent}
                    myPointAnswer={myPointConstruction}
                    myAnswerStep={myConstructionStep}
                    problemType={problemInfo.problemType}
                    startAnimation={myAnswerRaw.startAnimation}
                />
                <div className='horizontal-flex-container'>
                    {/* <button 
                        className='button'
                        onClick={() => navigateto(`/door/problem/${problemURL}`)}
                    >
                        문제로 돌아가기
                    </button> */}
                    <button 
                        className='button'
                        onClick={() => navigateto(`/door/problem/my/${doorProbIDMy}`, {state:{
                            "problemURL": problemURL,
                            "problemInfo": problemInfo,
                            "myAnswerList": myAnswerList
                        }})}
                    >
                        풀이 보기
                    </button>
                </div>
            </div>
            <br/>
        </div>
    );
};

export default DoorProblemMySolAnimation;